<footer class="gather-footer">
  <div class="footer-container">
    <div class="privacy-links">
      <span>{{"footer.privacy-policy" | translate}}</span>
      <a mat-button color="primary" href="{{privacyPolicyUrlAquent}}" id="privacy-policy-link-auth" target="_blank">{{"footer.aquent" | translate}}</a>
      <mat-divider [vertical]="true" class="divider"></mat-divider>
      <a mat-button color="primary" href="{{privacyPolicyUrlSkill}}" id="privacy-policy-link-skill" target="_blank">{{"footer.skill" | translate}}</a>
    </div>
  </div>
</footer>
